import { Component, OnDestroy, OnInit, AfterViewInit  } from '@angular/core';
import { from, Subject } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

import { ApiPrefixService, AppStateService, AuthService, MenuService } from 'yardi-angular-framework-bootstrap';
import localeIn from '@angular/common/locales/en-IN';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeIn, 'en-IN');
import * as menuData from './static-menu.json';
import { GlobalStateService } from './services/globalState.service';
import { HttpClient } from '@angular/common/http';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UserInfoCompanyModalComponent } from '../app-access/pages/userinfoCompanyModal';
// import { WarningDialogComponent } from './pages/session-timeout/warning-dialog.component';
// import { ForcemfaModalComponent } from './pages/forcemfa/forcemfa-modal.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnDestroy, OnInit, AfterViewInit  {
  destroy$ = new Subject();
  hasMultipleCompanies = false;

  constructor(
    private authService: AuthService,
    private menuService: MenuService,
    private globalState: GlobalStateService,
    private http: HttpClient,
    private apiPrefix: ApiPrefixService,
    private appState: AppStateService,
    private idle: Idle,
    private modal: NgbModal,
    private router: Router,
  ) {
    let modalInstance: NgbModalRef;

    // Set static menus for app
    setTimeout(() => {
      menuService.loadMenu(menuData, false);
    }, 500)
    this.menuService.UserMenu = [
        { Order: 1, Text: 'My Profile', IconClass: ['fas', 'user-circle'], Route: '/profile' },
        { Order: 2, Text: 'My DataRooms', IconClass: ['fas', 'th'], Route: '/datarooms-modal' }
      ];

    if (window.localStorage.getItem('UseForPreview') == '1') {
      globalState.isPreviewPortal = true;
    } else {
      globalState.isPreviewPortal = false;
    }

    //Start Idle watch
    if (!globalState.isPreviewPortal) {
      //http.get(this.apiPrefix.connect + "CompanyConfiguration/getIdleTimeOut").subscribe((response: any) => {
        //let tempIdleTimeOut = typeof response.TimeOut != 'undefined' ? response.TimeOut : 0;
        let tempIdleTimeOut =10;
        if (tempIdleTimeOut > 0) {
          tempIdleTimeOut = tempIdleTimeOut - 1;
          globalState.IdleTimeOut = tempIdleTimeOut;
          idle.setIdle(tempIdleTimeOut * 60);
          idle.setTimeout(60); // how long can they be idle before considered timed out, in seconds
          idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
          idle.watch();
        }
      //});
    }
    idle.onIdleStart.subscribe(() => {
      modalInstance?.close();
      // Show modal or alert to notify user they are idle
      //modalInstance = this.modal.open(WarningDialogComponent);
      modalInstance.componentInstance.idle = this.idle;
    })

    idle.onIdleEnd.subscribe(() => {
      // Hide modal or alert when user is no longer idle
      modalInstance?.close();
    });

    idle.onTimeout.subscribe(() => {
      // Close modal or alert when user times out
      modalInstance?.close();
      // Handle timeout, e.g., log out user or redirect to login page
      this.authService.logOut();
      window.location = this.appState.config.loginUrl;
    });


  }
  ngOnInit(): void {
    this.isMFATurnedOn();
    this.setupDataRoomsModalRoute();
    this.checkCompaniesAndSetupMenu();
    this.loadCustomCSS();
  }

  loadCustomCSS(): void {
    // Load custom.css dynamically after Angular initializes to ensure it overrides Bootstrap
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'styles/brandingcss';
    link.id = 'custom-branding-css';
    
    // Remove existing link if it exists (from index.html)
    const existingLink = document.getElementById('custom-branding-css');
    if (existingLink) {
      existingLink.remove();
    }
    
    document.head.appendChild(link);
  }

  isMFATurnedOn() {
    if (this.globalState.isPreviewPortal) {
    } else {
      this.http.get<any>(`${this.apiPrefix.connect}portaluser/enablemfa`)
        .subscribe({
          next: (response: any) => {
            if (response === true) {
              // const modalRef = this.modal.open(ForcemfaModalComponent, { size: 'xl' });
              // return from(modalRef.result.then(result => {
              //   if (result?.IsMFAEnabled !== undefined) {
              //     if (result.IsMFAEnabled) {
              //       return true;
              //     }
              //     else {
              //       window.localStorage.clear();
              //       this.authService.logOut();
              //       return false;
              //     }
              //   }
              // }, reason => reason = false));
            }
          },
          error: (err: any) => {

          },
          complete: () => { }
        });
    }
  }

  saveActualUserActivity(ObjectId, ObjectType) {
    this.http.post(`${this.apiPrefix.connect}dataroomuseractivity/ObjectAudit/${ObjectId}/${ObjectType}/view`, {})
      .subscribe({
        next: (response: any) => {

        },
        error: (err: any) => {

        },
        complete: () => { }
      });
  }

  /**
   * Sets up listener for datarooms modal route
   */
  setupDataRoomsModalRoute(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (event.url === '/datarooms-modal') {
          // Prevent actual navigation and open modal instead
          this.openDataRoomsModal();
        }
      });
  }

  /**
   * Checks for multiple companies and sets up user menu accordingly
   */
  checkCompaniesAndSetupMenu(): void {
    this.getCompaniesForDataRooms().then(companies => {
      this.hasMultipleCompanies = companies && companies.length > 1;
      this.setupUserMenu();
    }).catch(() => {
      this.hasMultipleCompanies = false;
      this.setupUserMenu();
    });
  }

  /**
   * Sets up the user menu based on company availability
   */
  setupUserMenu(): void {
    const userMenu = [
      { Order: 1, Text: 'My Profile', IconClass: ['fas', 'user-circle'], Route: '/profile' },
    ];

    // Only add My DataRooms menu if user has multiple companies
    if (this.hasMultipleCompanies) {
      userMenu.push({ Order: 2, Text: 'My DataRooms', IconClass: ['fas', 'th'], Route: '/datarooms-modal' });
    }

    //userMenu.push({ Order: 3, Text: 'Account Activity', IconClass: ['fas', 'list-check'], Route: '/accountactivity' });

    this.menuService.UserMenu = userMenu;
  }

  /**
   * Opens the company selection modal for DataRooms
   */
  openDataRoomsModal(): void {
    // Get companies data - for now using mock data, replace with actual API call
    this.getCompaniesForDataRooms().then(companies => {
      if (companies && companies.length > 1) {
        const modalRef = this.modal.open(UserInfoCompanyModalComponent, { 
          size: 'xl',
          backdrop: 'static',
          keyboard: false 
        });
        
        modalRef.componentInstance.ShareObj = {
          CompaniesList: companies
        };

        from(modalRef.result).subscribe({
          next: (result) => {
            // if (result && result.isSelected && result.company) {
            //   // Company was selected, navigate to deal dashboard with company context
            //   this.navigateToDataRoomsWithCompany(result.company);
            // } else {
            //   // User cancelled or no selection, stay on current page
            //   this.router.navigate(['/']); // Navigate to home or current page
            // }
            // No companies available, go directly to deal dashboard
            // User cancelled or no selection, stay on current page
            this.router.navigate(['/deal-dashboard']); // Navigate to deal dashboard
          },
          error: (error) => {
            console.log('Modal dismissed', error);
            this.router.navigate(['/deal-dashboard']); // Navigate back on error
          }
        });
      } else {
        // No companies available, go directly to deal dashboard
        this.router.navigate(['/deal-dashboard']);
      }
    });
  }

  /**
   * Gets companies list for DataRooms selection
   * TODO: Replace this with actual API call to get user's companies
   */
  private async getCompaniesForDataRooms(): Promise<any[]> {
    try {
      // TODO: Replace with actual API endpoint
      // Example: const response = await this.http.get<any[]>(`${this.apiPrefix.connect}companies/datarooms`).toPromise();
      
      // For now, return mock data - replace with actual HTTP call
      return new Promise((resolve) => {
        setTimeout(() => {

          this.isMultiCompany().subscribe((Companies) => {
            resolve(Companies as any[] || []);
          });

          
        }, 100);
      });
      
    } catch (error) {
      console.error('Error fetching companies:', error);
      return [];
    }
  }

  /**
   * Navigates to DataRooms with selected company context
   */
  private navigateToDataRoomsWithCompany(company: any): void {
    // Store selected company in session/local storage or service
    sessionStorage.setItem('selectedCompany', JSON.stringify(company));
    
    // Navigate to deal dashboard
    this.router.navigate(['/deal-dashboard'], {
      queryParams: { 
        company: company.domain,
        user: company.username 
      }
    });
  }
  isMultiCompany() {
    return this.http.get(`${this.apiPrefix.rootPath}portaluser/checkuserdomain`);
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
  ngAfterViewInit(): void {
    this.addFooterLink();
  }

    addFooterLink(): void {
    // Wait for footer to be rendered by the framework
    setTimeout(() => {
      const footer = document.querySelector('.app-footer');
      if (footer) {
        // Check if link already exists to avoid duplicates
        const existingLink = footer.querySelector('.privacy-statement');
        if (!existingLink) {
          // Find the wrapper div (which contains copyright)
          const wrapper = footer.querySelector('.wrapper');
          
          if (wrapper) {
            const wrapperElement = wrapper as HTMLElement;
            
            // Remove text-right from wrapper since we need both left and right alignment
            // We'll apply text-right only to the copyright span
            if (wrapperElement.classList.contains('text-right')) {
              wrapperElement.classList.remove('text-right');
            }
            
            // Add flexbox classes or styles to wrapper for proper alignment
            // This allows privacy on left and copyright on right
            wrapperElement.style.display = 'flex';
            wrapperElement.style.justifyContent = 'space-between';
            wrapperElement.style.alignItems = 'center';
            
            // Create privacy statement span
            const linkSpan = document.createElement('span');
            linkSpan.className = 'privacy-statement pull-left';
            
            const link = document.createElement('a');
            link.href = 'https://resources.yardi.com/legal/privacy-statement/';
            link.target = '_blank';
            link.textContent = 'Site Privacy Statement';
            link.style.textDecoration = 'none';
            
            linkSpan.appendChild(link);
            
            // Find copyright span and ensure it has text-right
            const copyright = wrapperElement.querySelector('.copyright');
            if (copyright && !copyright.classList.contains('text-right')) {
              copyright.classList.add('text-right');
            }
            
            // Insert the privacy statement INSIDE the wrapper div, before the copyright
            // This ensures both elements are inside the wrapper for proper alignment
            wrapperElement.insertBefore(linkSpan, wrapperElement.firstChild);
          }
        }
      }
    }, 500); // Delay to ensure footer is rendered
  }



}
